import {
  Center,
  GreyGrey30,
  GreyGrey80,
  IconArrowUpRight,
  IndigoIndigo50
} from '@sequencehq/core-components'
import { ContractReference } from 'Cube/domain/cube.domain.types'
import { FC, SyntheticEvent } from 'react'
import { CONTRACT_REFERENCE_TYPE_CONFIG } from './contractReferences.constants'
import { getWebUrl } from './contractReferences.helpers'

/**
 * Opens a reference's link in a new tab. Renders nothing for a reference
 * without a web address, so a typed-in link like "Shared drive" is never
 * followed.
 */
export const ContractReferenceLink: FC<{
  reference: ContractReference
  /** Width and height of the clickable area. */
  size?: string
  'data-testid': string
}> = ({ reference, size = '16px', 'data-testid': dataTestId }) => {
  const webUrl = getWebUrl(reference.url)

  if (!webUrl) {
    return null
  }

  const { label: typeLabel } = CONTRACT_REFERENCE_TYPE_CONFIG[reference.type]

  return (
    <Center
      as="a"
      href={webUrl}
      target="_blank"
      rel="noopener noreferrer"
      width={size}
      height={size}
      flexShrink={0}
      borderRadius="4px"
      _hover={{ color: GreyGrey80, background: GreyGrey30 }}
      _focusVisible={{
        outline: `2px solid ${IndigoIndigo50}`,
        outlineOffset: '1px'
      }}
      // A link inside a clickable pill shouldn't also open its change dialog.
      onClick={(e: SyntheticEvent) => e.stopPropagation()}
      aria-label={`Open ${typeLabel.toLowerCase()} ${reference.label}`}
      data-testid={dataTestId}
    >
      <IconArrowUpRight />
    </Center>
  )
}
